import React from "react";
import { TableCell, TableRow, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { NEGATIVE_COLOR, VALUE_FONT_WEIGHT } from "../../Constants";
import WalletIcon from "../layout/WalletIcon";
import { selectWalletById } from "../../store/walletSlice";
import { selectCurrencies } from "../../store/currencySlice";
import { selectCategory } from "../../store/categorySlice";
import {useTranslation} from "react-i18next";

const TransactionExpense = ({ transaction, onClick }) => {
    const {t} = useTranslation();
    const description = transaction.description || t("common.transactionType.expense");
    const value = transaction.valueFrom;
    const wallet = useSelector((state) => selectWalletById(state, transaction.walletFrom));
    const currencies = useSelector(selectCurrencies) || [];
    const currency = wallet?.currency != null
        ? currencies.find((c) => c.id === wallet.currency || c.id == wallet.currency)
        : null;
    const displayValue = currency?.shortName ? `${value} ${currency.shortName}` : value;
    const category = useSelector(selectCategory(transaction.categoryTo));
    const categoryLabel = category?.name || (transaction.categoryTo != null ? String(transaction.categoryTo) : "");

    const isDraft = transaction?.state === "DRAFT";

    return (
        <TableRow
            key={transaction.id}
            className={isDraft ? "Draft" : undefined}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            onClick={(event) => onClick(transaction)}
        >
            <TableCell padding="none" align="center" sx={{ width: 56 }}>
                {wallet && <WalletIcon image={wallet.image} sx={{ fontSize: 28 }} />}
            </TableCell>
            <TableCell component="th" scope="row">
                <Typography variant="body1">{description}</Typography>
                <Typography variant="body2" color="text.secondary">
                    {categoryLabel}
                </Typography>
            </TableCell>
            <TableCell align="right">
                <Typography variant="body1" sx={{ color: NEGATIVE_COLOR, fontWeight: VALUE_FONT_WEIGHT }}>
                    −{displayValue}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

TransactionExpense.propTypes = {
    transaction: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        description: PropTypes.string,
        valueFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        walletFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
    onClick: PropTypes.func.isRequired,
};

export default TransactionExpense;
